module.exports = __webpack_public_path__ + "static/media/dog.ebc54105.webp";